import React, { Component } from "react";
import browserUserAgent from "browserslist-useragent";
import { browserslist as supportedBrowsers } from "../../package.json";
import browserslist from "browserslist";
import { upperFirst, uniq } from "lodash-es";
import { Alert } from "react-bootstrap";

export default class BrowserWarning extends Component {
  constructor(props) {
    super(props);

    this.state = {
      visible: !browserUserAgent.matchesUA(navigator.userAgent, {
        browsers: supportedBrowsers,
        allowHigherVersions: true
      })
    };
  }

  get supportedBrowsers() {
    return uniq(
      browserslist(supportedBrowsers).map(browser =>
        upperFirst(browser.replace(/ .*/, ""))
      )
    );
  }

  handleClickClose = () => {
    this.setState({ visible: false });
  };

  render() {
    return (
      this.state.visible && (
        <Alert variant="warning" dismissible onClose={this.handleClickClose}>
          The current browser is not supported. Please use the latest version of
          the following browsers: {this.supportedBrowsers.join(", ")}.
        </Alert>
      )
    );
  }
}
